import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
} from '@chakra-ui/react';

import { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';

type Props = {
  register: UseFormRegister<NotificationFormFields>;
  error: FieldError | undefined;
};

/**
 * お知らせ本文のフォームです。
 * Chakra の Textarea は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const MessageForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <FormLabel>本文</FormLabel>
    <Textarea
      id="message"
      {...register('message', {
        required: '必須項目です。',
      })}
      rows={10}
    />
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
